module.exports = __webpack_public_path__ + "img/FHWP_skull_axe.0ab0ca17.png";